import { createI18n } from 'vue-i18n';
import id from './id';
import en from './en';

const STORAGE_KEY = 'arspo:locale';
/* Kunci sebelum penggantian merek. Dibaca sekali lalu dipindahkan
   supaya pilihan pengguna yang sudah tersimpan tidak hilang. */
const STORAGE_KEY_LAMA = 'cendrawasih:locale';
export const SUPPORTED_LOCALES = ['id', 'en'];
const FALLBACK_LOCALE = 'id';

/**
 * Menentukan bahasa awal.
 *
 * HANYA pilihan yang pernah disimpan pengguna yang dipakai. Bahasa peramban
 * SENGAJA tidak dideteksi.
 *
 * Alasannya: ini platform turnamen pencak silat di Indonesia, dan penggunanya
 * — official, pelatih, panitia — berbahasa Indonesia. Banyak dari mereka
 * memakai Windows atau Chrome berbahasa Inggris, sehingga deteksi peramban
 * justru menyuguhkan bahasa yang salah pada kunjungan pertama. Bahasa Inggris
 * tetap tersedia, tetapi harus dipilih sendiri.
 */
function detectLocale() {
  try {
    let saved = localStorage.getItem(STORAGE_KEY);

    // Pindahkan pilihan yang tersimpan di bawah kunci merek lama.
    if (saved === null) {
      const lama = localStorage.getItem(STORAGE_KEY_LAMA);
      if (lama !== null) {
        saved = lama;
        localStorage.setItem(STORAGE_KEY, lama);
        localStorage.removeItem(STORAGE_KEY_LAMA);
      }
    }
    if (saved && SUPPORTED_LOCALES.includes(saved)) return saved;
  } catch (error) {
    // localStorage diblokir (mode penyamaran) — pakai bawaan.
  }

  return FALLBACK_LOCALE;
}

const i18n = createI18n({
  legacy: false,          // Composition API
  globalInjection: true,  // $t tersedia langsung di template Options API
  locale: detectLocale(),
  fallbackLocale: FALLBACK_LOCALE,
  messages: { id, en },
  // Kunci yang belum diterjemahkan tidak perlu memenuhi konsol saat pengembangan.
  silentFallbackWarn: true,
  silentTranslationWarn: true,
});

/**
 * Mengganti bahasa aktif dan menyimpannya.
 * Atribut lang pada <html> ikut diperbarui — penting untuk pembaca layar
 * dan untuk aturan pemenggalan kata peramban.
 */
export function setLocale(locale) {
  if (!SUPPORTED_LOCALES.includes(locale)) return;

  i18n.global.locale.value = locale;
  document.documentElement.setAttribute('lang', locale);

  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch (error) {
    // Gagal menyimpan bukan alasan membatalkan pergantian bahasa.
  }
}

export function getLocale() {
  return i18n.global.locale.value;
}

// Terapkan atribut lang untuk bahasa awal.
document.documentElement.setAttribute('lang', i18n.global.locale.value);

export default i18n;
